import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {Person} from '../../person/person';
import {Entity} from '../../entity/entity';
import {PersonService} from '../../services/person-service';
import {EntityService} from '../../services/entity-service';
import {StringUtils} from '../../utils/string-utils';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


@Component({
    selector: 'skyport-contact-dialog',
    templateUrl: './skyport-contact-dialog.component.html',
    styleUrls: ['./skyport-contact-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatProgressSpinner, FormsModule, MatDialogActions, MatButton]
})
export class SkyportContactDialogComponent {
  private readonly personService = inject(PersonService);
  private readonly entityService = inject(EntityService);
  dialogRef = inject<MatDialogRef<SkyportContactDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  readonly person = signal<Person>(undefined!);
  public entity: Entity;
  readonly isBusy = signal<boolean>(undefined!);
  readonly errorMessage = signal<string>(undefined!);

  constructor
  () {
    const data = this.data;

    this.entity = data.entity as Entity;
    this.getSkyportContact();
  }

  public saveAndClose(): void {
    this.isBusy.set(true);
    this.errorMessage.set(undefined!);
    this.validateRequiredFields();
    if (!this.errorMessage() || this.errorMessage().length == 0) {
      this.personService.saveSkyportContact(this.person(), this.entity).subscribe(result => {
        this.dialogRef.close(this.entity);
      }, error => this.handleError(error));
    } else {
      this.isBusy.set(false);
    }
  }

  private getSkyportContact(): void {
    this.personService.getSkyportContact(this.entity).subscribe(result => {
      this.person.set(result);
      if (this.person() == null) {
        this.person.set(new Person());
      }
    }, error => this.handleError(error));
  }

  private validateRequiredFields(): void {
    if (!this.person().firstName || this.person().firstName.length == 0) {
      this.errorMessage.set('Contact First Name is required');
    } else if (!this.person().lastName || this.person().lastName.length == 0) {
      this.errorMessage.set('Contact Last Name is required');
    } else if (!this.person().managerName || this.person().managerName.length == 0) {
      this.errorMessage.set('Company Name is required');
    } else if (!this.person().defaultPhoneNumber || this.person().defaultPhoneNumber.length == 0) {
      this.errorMessage.set('Contact Phone Number is required');
    } else if (!this.person().emailAddress.emailAddress || this.person().emailAddress.emailAddress.length == 0) {
      this.errorMessage.set('Contact E-Mail is required');
    }
  }

  private handleError(error: HttpErrorResponse): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }

}
